const storeConfig = `{
    storeConfig {
        code
        header_logo_src
        logo_alt        
        locale        
        catalog_default_sort_by
        product_url_suffix
        default_title
        default_description
        default_keywords
        intercom_app_id
        merchant_id
        googletagmanager_container_id
        stripe_config {
            api_key
        }
        cardnet_config {
            lib_url
            connect_pay_form_url
        }
        paypal_config {
            client_id
        }
        amazon_config {
            button_color
            currency
            language
            merchant_id
            placement
            product_type
            public_key_id
            sandbox
        }
        footer_logo_src
        footer_logo_alt
        affiliate_enabled
        affiliate_referral_param
        affiliate_cookie_lifetime_days
        shopping_cart_display_price
        header_mobile_logo_src
        trustpilot_installation_key
        cloudflare_captcha {
            site_key
        }
        cookieconsent_update_interval
        cookieconsent_cookie_lifetime
        placeholder
        trustpilot {
            trustpilot_organization_rating_value
            trustpilot_organization_review_count
        }
    }
}`;

export default {
    storeConfig,
};
